import React from 'react';
import { useDelayedRender } from '../hooks';
export const DelayedRender = ({ delay = 250, children }) => {
    const dr = useDelayedRender(delay);
    return dr(() => React.createElement(React.Fragment, null, children));
};
//# sourceMappingURL=DelayedRender.js.map